import { render, staticRenderFns } from "./GJgrowEventDetail.vue?vue&type=template&id=a65df490&"
import script from "./GJgrowEventDetail.vue?vue&type=script&lang=ts&"
export * from "./GJgrowEventDetail.vue?vue&type=script&lang=ts&"
import style0 from "./GJgrowEventDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports